module.exports = __webpack_public_path__ + "media/images/flags/16/Olympics-9972632093ffe78b79a600c2b9d6e8d4.png";